import TaskAssigneeField from '../components/tasks/fields/TaskAssigneeField.vue'
import TaskDeadlineField from '../components/tasks/fields/TaskDeadlineField.vue'
import TaskPriorityField from '../components/tasks/fields/TaskPriorityField.vue'
import TaskStatusField from '../components/tasks/fields/TaskStatusField.vue'
import TaskTitleField from '../components/tasks/fields/TaskTitleField.vue'

const formatDate = (value) => {
  return value ? new Date(value).toLocaleDateString() : '-'
}

export const TASK_LIST_CONTEXT_ROUTE_MAP = {
  my_tasks: 'my-active-tasks',
  my_active_tasks: 'my-active-tasks',
  my_drafts: 'my-drafts',
  incoming: 'incoming',
  assigned_out: 'assigned-out',
  my_completed_tasks: 'my-completed-tasks',
}

export const TASK_LIST_CONTEXT_OPTIONS = [
  { value: 'my_active_tasks', label: 'My Active Tasks' },
  { value: 'my_drafts', label: 'My Drafts' },
  { value: 'incoming', label: 'Incoming' },
  { value: 'assigned_out', label: 'Assigned Out' },
  { value: 'my_completed_tasks', label: 'My Completed Tasks' },
]

export const TASK_TABLE_FIELDS = [
  { name: 'id', label: 'ID', sortable: true },
  { name: 'title', label: 'Title', sortable: true, searchable: true, component: TaskTitleField },
  { name: 'status', label: 'Status', sortable: true, component: TaskStatusField },
  { name: 'priority', label: 'Priority', sortable: true, component: TaskPriorityField },
  { name: 'assigned_to_user_id', label: 'Assigned To', sortable: true, component: TaskAssigneeField },
  {
    name: 'created_by_user_id',
    label: 'Created By',
    sortable: true,
    formatter: (value, row) => row?.cached?.created_by_user?.name ?? (value ? `User #${value}` : '-'),
  },
  { name: 'deadline_at', label: 'Deadline', sortable: true, component: TaskDeadlineField },
  { name: 'created_at', label: 'Created At', sortable: true, formatter: formatDate },
]

export const TASK_TABLE_COLUMNS_BY_CONTEXT = {
  default: ['id', 'title', 'status', 'priority', 'assigned_to_user_id', 'created_by_user_id', 'deadline_at', 'created_at'],
  my_tasks: ['id', 'title', 'status', 'priority', 'created_by_user_id', 'deadline_at', 'created_at'],
  my_active_tasks: ['id', 'title', 'status', 'priority', 'created_by_user_id', 'deadline_at', 'created_at'],
  my_drafts: ['id', 'title', 'status', 'priority', 'assigned_to_user_id', 'created_by_user_id', 'deadline_at', 'created_at'],
  incoming: ['id', 'title', 'status', 'priority', 'created_by_user_id', 'deadline_at', 'created_at'],
  assigned_out: ['id', 'title', 'status', 'priority', 'assigned_to_user_id', 'deadline_at', 'created_at'],
  my_completed_tasks: ['id', 'title', 'status', 'priority', 'created_by_user_id', 'deadline_at', 'created_at'],
}

export const getTaskListRouteContext = (context) => {
  const contextKey = String(context ?? '').trim()
  return TASK_LIST_CONTEXT_ROUTE_MAP[contextKey] ?? contextKey.replaceAll('_', '-')
}

export const getTaskTableFieldsForContext = (context) => {
  const contextKey = String(context ?? '').trim()
  const allowedColumns = TASK_TABLE_COLUMNS_BY_CONTEXT[contextKey] ?? TASK_TABLE_COLUMNS_BY_CONTEXT.default

  return TASK_TABLE_FIELDS.filter((field) => allowedColumns.includes(field.name))
}
